import { render, staticRenderFns } from "./ProductHome.vue?vue&type=template&id=efbf717c&scoped=true&"
import script from "./ProductHome.vue?vue&type=script&lang=js&"
export * from "./ProductHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbf717c",
  null
  
)

export default component.exports